import React, { useState } from "react";
import {Grid } from '@material-ui/core';
import { Box, ToggleButtonGroup, ToggleButton, Card, CardContent, Alert, AlertTitle, Button } from '@mui/material';
import MainCard from '../components/MainCard';
import StickyHeadOneButtonTable from '../components/StickyHeadOneButtonTable';
import axios from "../../components/axios";
import CustomDatePicker from '../components/CustomDatePicker';
import { useNavigate } from 'react-router-dom';
import { format, isValid } from 'date-fns';
import TextFieldCommon from '../components/Form/TextFieldCommon';


const TestCombinationsPage = () => {
  const navigate = useNavigate();
  const [alignment, setAlignment] = useState('and');
  const [rows, setRows] = useState([]);
  const [showTable, setshowTable] = useState(false);
  const [showAlert, setshowAlert] = useState(false);
  const [clickCalendar, setclickCalendar] = useState(0);
  const [search, setSearch] = useState("");
  function searchChange(e) {
    setSearch(e.target.value);
  }

  const [open, setOpen] = useState(false);
  const onChange = (ranges) => {
    if (clickCalendar === 0 ){
      setclickCalendar(clickCalendar+1)
    }else{
      setclickCalendar(0)
      if (ranges.startDate !== null && ranges.endDate !== null) {
        setOpen(false);
      }
    }
  };

  const [state, setState] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection"
    }
  ]);

  const styleButton = {
    backgroundColor: "#406599",
    color: "#fff",
    borderRadius: "5px",
    boxSizing: "border-box",
    width: "100px",
    height: "45px",
    fontFamily: '"Roboto", "sans-serif"',
    fontSize: "15px",
  };

  const styleToggle = {
    marginTop: "10px",
    color:'#406599',
    fontFamily: '"Roboto", "sans-serif"',
  };

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string,
  ) => {
    setAlignment(newAlignment);
  };

  const handleDetail = (uuid) => {
    navigate('/test-detail/'+uuid);
  };

  const handleQueryData = () => {
    console.log(state)
    if (search === "" && state[0].startDate === null && state[0].endDate === null ){
      alert("Please select query date range or keyword!");
    }else{
      setRows([]);
      let startDateStr = "";
      let endDateStr = ""
      if (state[0].startDate !== null && isValid(state[0].startDate)) {
        startDateStr = format(state[0].startDate, "yyyy-MM-dd")
      }
      if (state[0].endDate !== null && isValid(state[0].endDate)) {
        endDateStr = format(state[0].endDate, "yyyy-MM-dd")
      }

      var input_data = JSON.stringify({ query: search, start_date: startDateStr,
        end_date: endDateStr, condition: alignment })
      axios.post("/peloton/v1/automation/query-combination",input_data,{withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          if (response.data.data !== null){
            setRows(response.data.data);
            setshowTable(true);
          }else{
            setshowAlert(true);
          }
        }else{
          alert(response.data.message);
        }
      }).catch(function(err){
        if (!err.response){
          alert(err);
        }else{
          if (err.response.status === 401){
            navigate("/");
          }else{
            console.log('error.response.status: ', err.response.status);
            console.log('error.response.status: ', err.response.data.message);
            alert(err.response.data.message);
          }
        }
      })
    }
  };

  const handleClear = () => {
    setSearch('');
  };

const columns = [
  { id: 'token', label: 'Token' , align: 'left'},
  { id: 'jenkins_job', label: 'Jenkins Job', align: 'center'},
  { id: 'create_time', label: 'Trigger Time', align: 'center'},
  { id: 'finish_time', label: 'Finish Time', align: 'center'},
  { id: 'is_finish', label: 'Is Finish', align: 'center'},
  { id: 'action', label: 'Detail', align: 'center', action: true},
];

  return (
    <MainCard title="Test combinations">
      <Card variant="outlined" sx={{ bgcolor: "white" }}>
      <CardContent>
      <Box sx={{ fontSize: '20px', color:"#406599", pb:'15px'}}>
      Test combinations
      </Box>
      <Grid container direction="row" justifyContent="space-around" alignItems="center" >
        <Grid item xs={3}>
        <CustomDatePicker onChange={onChange} open={open} setOpen={setOpen} state={state} setState={setState}/>
        </Grid>
        <Grid item xs={4}>
          <TextFieldCommon search={search} searchChange={searchChange} handleClear={handleClear}/>
        </Grid>
        <Grid item xs={1}>
          <ToggleButtonGroup
            color="error"
            size="small"
            value={alignment}
            exclusive
            onChange={handleChange}
            style={styleToggle}
          >
            <ToggleButton value="and" color="info">AND</ToggleButton>
            <ToggleButton value="or" color="info">OR</ToggleButton>
          </ToggleButtonGroup>
        </Grid>
        <Grid item xs={1}>
          <Button style={styleButton} onClick={handleQueryData}>Search</Button>
        </Grid>
      </Grid>
      </CardContent>
      </Card>
      { showTable && (<StickyHeadOneButtonTable rows={rows} columns={columns} handleDetail={handleDetail} title="Test Queue"/>)}
      { showAlert && (<Card variant="outlined" sx={{ bgcolor: "white" }}><Alert severity="warning">
        <AlertTitle>Warning</AlertTitle>
        No data in this condition.
      </Alert></Card>)}
    </MainCard>)
};

export default TestCombinationsPage;
